<template>
  <div class="main view-home">

    <div class="content">
      <h1>Simply upload a picture of you and your&nbsp;
        <br />Jeep Grille to be in the draw to&nbsp;
        <br /><span>win a brand new Jeep Renegade Longitude!&nbsp;</span>
      </h1>

      <div v-if="this.$store.state.mobileDevice" class="links">
        <div class="option">
          <img src="../assets/jeep-camera.svg" alt="Camera">
          <input @change="imageUpload" class="camera" type="file" name="image" accept="image/*" capture="user">
          <span>Take a photo</span>
        </div>

        <div to="/upload" class="option">
          <img src="../assets/jeep-upload.svg" alt="Upload">
          <input @change="imageUpload" class="upload" type="file" name="upload" accept="image/*">
          <span>Choose from camera roll</span>
        </div>
      </div>

      <div v-else class="links">
        <div to="/upload" class="option">
          <img src="../assets/jeep-upload.svg" alt="Upload">
          <input @change="imageUpload" class="upload" type="file" name="upload" accept="image/*">
          <span>Upload image</span>
        </div>
      </div>

      <img :src="image">

      <div class="vehicle">
        <img src="../assets/jeep-vehicle.png" alt="Jeep vehicle">
      </div>

    </div>

  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'home',
  data () {
    return {
      source: 'camera',
      image: '',
      hasImage: null,
      imageOrientation: 1,
    }
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  watch: {
    image () {
      console.log('Image added')
      this.$store.state.isLoading = true
      // this.$store.commit('updatePayload', this.image)
      this.$store.state.payload.image = this.image
      if (this.source === 'camera') {
        this.$store.state.imageSource = 'camera'
      } else {
        this.$store.state.imageSource = 'upload'
      }
      this.$router.push({ path: 'camera' })
    }
  },
  methods: {
    imageUpload (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      console.log('file size', files[0])
      // if (files[0].size > 1663000) {
      //   console.log('file size too big', files[0].size)
      //   return
      // }
      if (e.target.className === 'upload') {
        this.$store.state.imageSource = 'upload'
      } else {
        this.$store.state.imageSource = 'camera'
      }

      this.createImage(files[0])
    },
    createImage (file) {
      let reader = new FileReader()
      let vm = this

      reader.onload = (e) => {
        // RESIZE CANVAS
        let resizeCanvas = document.createElement('canvas')
        let rctx = resizeCanvas.getContext('2d')
        let rimg = new Image()

        rimg.src = e.target.result

        rimg.onload = function () {
          let ratio = vm.getAspectRatio(rimg.width, rimg.height)

          resizeCanvas.width = ratio.width
          resizeCanvas.height = ratio.height
          rctx.drawImage(rimg, 0, 0, ratio.width, ratio.height)

          // if (vm.$store.state.imageSource === 'camera' && vm.$store.state.mobileDevice) {
            let EXIF = require('exif-js')

            EXIF.getData(rimg, function() {
              let allMetaData = EXIF.getAllTags(this)
              let orientation = allMetaData.Orientation

              if (orientation > 2) {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                let img = new Image()

                img.src = resizeCanvas.toDataURL()
                canvas.width = ratio.width
                canvas.height = ratio.height

                img.onload = function () {
                  ctx.drawImage(img, canvas.width / 2 - img.width / 2, canvas.height / 2 - img.width / 2)

                  ctx.clearRect(0, 0, canvas.width, canvas.height)
                  ctx.save()
                  ctx.translate(canvas.width / 2, canvas.height / 2)

                  switch (orientation) {
                    case 3: ctx.rotate(180 * Math.PI / 180)
                      break
                    case 4: ctx.rotate(-180 * Math.PI / 180)
                      break
                    case 5: ctx.rotate(90 * Math.PI / 180)
                      break
                    case 6: ctx.rotate(90 * Math.PI / 180)
                      break
                    case 7: ctx.rotate(-90 * Math.PI / 180)
                      break
                    case 8: ctx.rotate(-90 * Math.PI / 180)
                      break
                   }

                  ctx.drawImage(img, -img.width / 2, -img.width / 2)
                  ctx.restore()

                  vm.image = canvas.toDataURL()
                }
              } else {
                vm.image = resizeCanvas.toDataURL()
              }
            })
          // } else {
          //   vm.image = resizeCanvas.toDataURL()
          // }
        }
      }
      reader.readAsDataURL(file)
    },
    getAspectRatio (srcWidth, srcHeight) {
      let ratio = srcWidth / srcHeight

      return {
        width: 1000,
        height: Math.ceil(1000 / ratio)
      }
    },
    isPortrait (img) {

      console.log('reading exif')

      // let w = img.naturalWidth || img.width
      // let h = img.naturalHeight || img.height
      // console.log('orientation')
      // console.log(w)
      // console.log(h)
      return true
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
.view-home {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  .content h1 {
    margin: 30px 0;
  }

  .links {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: center;
    margin: auto 0 30px;
  }

  .option {
    position: relative;
    margin: 30px 25px 0;
    text-align: center;

    img {
      margin: 0 auto 16px;
      max-height: 50px;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    span {
      display: block;
      max-width: 100px;
      margin: 0 auto;

      font-size: 14px;
      font-weight: 700;

      color: white;
    }
  }

  .vehicle {
    position: relative;
    width: 100%;
    padding: 60px 0;
    margin: auto 0 0;

    &:before,
    &:after {
      position: absolute;
      bottom: 0;
      left: 0;

      content: '';
      width: 100%;
      height: 150px;

      background: $grey-3;

      @media (min-width: $smallish) {
        left: 100%;
        width: 9999px;
      }
    }

    &:before {
      @media (min-width: $smallish) {
        right: 0;
        left: auto;
      }
    }

    img {
      position: relative;
      z-index: 1;
      margin: 0 auto;
    }
  }
}
</style>
